module.exports = __webpack_public_path__ + "img/v2-redesign-research-preview.a7669dd8.png";